export let ApiTokensMethods;

(function (ApiTokensMethods) {
  ApiTokensMethods["CLIENT_CREDENTIALS"] = "clientCredentials";
  ApiTokensMethods["ACCESS_TOKEN"] = "accessToken";
})(ApiTokensMethods || (ApiTokensMethods = {}));